import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchResearchData,
  fetchPublicationData,
  downloadPublicationFile,
  fetchInternshipData,
} from "../../redux/slicer/researchAndStudentSlice";
import { TiArrowSortedDown } from "react-icons/ti";
import { FaLink, FaArrowUp } from "react-icons/fa";
import { BsFileEarmarkPdfFill } from "react-icons/bs";
import { IoIosArrowForward } from "react-icons/io";
import { QRCodeSVG } from "qrcode.react";
import Background from "../../assets/Background3.png";
import Preloader from "../../assets/sab.jpeg";
import StudentlifeImG from "../../assets/Banners/StudentLife.jpg";
import parse from "html-react-parser";

function ResearchAndStudentLife() {
  const dispatch = useDispatch();
  const [expandedAbstracts, setExpandedAbstracts] = useState({});
  const [activePublication, setActivePublication] = useState(null);

  const togglePublication = (id) => {
    setActivePublication(activePublication === id ? null : id);
  };
  const {
    data: researchData,
    loading: researchLoading,
    error: researchError,
  } = useSelector((state) => state.research.research);
  const {
    data: publicationData,
    loading: publicationLoading,
    error: publicationError,
  } = useSelector((state) => state.research.publication);
  const {
    data: internshipData,
    loading: internshipLoading,
    error: internshipError,
  } = useSelector((state) => state.research.internship);

  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    dispatch(fetchResearchData());
    dispatch(fetchPublicationData());
    dispatch(fetchInternshipData());
  }, [dispatch]);

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth",
    });
  };

  const getFilenameFromUrl = (url) => {
    try {
      const urlObject = new URL(url);
      const pathname = urlObject.pathname;
      const filename = pathname.substring(pathname.lastIndexOf('/') + 1);
      return decodeURIComponent(filename); // Decode URL-encoded characters
    } catch (error) {
      console.error("Error parsing URL:", error);
      return "Unknown File";
    }
  };
  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const toggleAbstract = (id) => {
    setExpandedAbstracts((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  const toggleTab = (year) => {
    setActiveTab(activeTab === year ? null : year);
  };
  const MAX_WORDS = 50;

  const truncateText = (text, id) => {
    if (expandedAbstracts[id] || text.split(" ").length <= MAX_WORDS) {
      return text;
    }
    return text.split(" ").slice(0, MAX_WORDS).join(" ") + "...";
  };

  if (researchLoading || publicationLoading || internshipLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <img
          src={Preloader}
          alt="Loading..."
          className="w-24 h-24 sm:w-32 sm:h-32"
        />
      </div>
    );
  }

  if (researchError || publicationError || internshipError) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <p className="text-red-600 text-lg font-bold">
          Error: {researchError || publicationError || internshipError}
        </p>
      </div>
    );
  }

  const posterData = {
    imageUrl:
      "https://www.casrilanka.com/casl/images/2024/SAB/2024-10-11/sabresearch.jpg",
    title: "Call for Submissions!",
    description: "Submit your research papers now!",
  };

  const qrCodeLink = "google.com";

  return (
    <div>
      {/* Hero Section */}
      <div className="relative max-w-full mx-auto">
        <div className="overflow-hidden w-full  h-[300px] sm:h-[400px]">
          <img
            src={StudentlifeImG}
            alt="carousel-slide"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 text-center text-white">
            <h2 className="text-3xl sm:text-5xl font-bold  font-titillium">
              Research and Publications
            </h2>
            <p className="text-base sm:text-lg mt-4 sm:mt-10  font-titillium">
   
            </p>
          </div>
        </div>
      </div>

      {/* Link Section */}
      {/* <div className="flex justify-end mr-5 mt-6">
        <div className="flex items-center gap-2 text-primary-color">
          <span>
            <a
              href="/research-and-student-life#clubs"
              className="text-primary-color underline hover:text-secondary-color"
            >
              Go to Student Life
            </a>
          </span>
          <FaLink />
          <TiArrowSortedDown
            onClick={scrollToBottom}
            className="cursor-pointer text-xl hover:text-secondary-color"
          />
        </div>
      </div> */}

      {/* Research Section */}
      <div className="py-6 px-4 sm:px-6 lg:px-28">
        <p className="text-primary-color text-4xl  font-titillium">Research</p>
      </div>

      {/* ... (rest of your component) ... */}

      <div className="mt-5 py-5 px-4 sm:px-6 lg:px-28" id="src">
        <h2 className="text-left text-primary-color text-4xl font-titillium">
          {" "}
          <a
            href="https://www.casrilanka.com/casl/index.php?option=com_content&view=article&id=3782&Itemid=554&lang=en"
            target="_blank"
            rel="noopener noreferrer"
          >
            SAB SRC
          </a>
        </h2>
        <div className="bg-primary-color h-[1px] w-[150px] mt-5 "></div>
        <div className="py-6 mt-6">
          <div className="w-full flex flex-col items-center">
            {/* Tab Header */}
            <div className="w-full sm:w-[98%] border border-gray-300 rounded-xl overflow-hidden">
              {Object.keys(researchData).map((year) => (
                <div key={year} className="border-b border-gray-300">
                  {/* Tab Bar */}
                  <button
                    className={`w-full text-left py-4 px-6 text-base sm:text-xl font-semibold flex justify-between items-center ${
                      activeTab === year
                        ? "bg-gray-200 text-primary-color"
                        : "text-gray-600"
                    }`}
                    onClick={() => toggleTab(year)}
                  >
                    {year}
                    <span
                      className={`ml-4 transform transition-transform duration-300 ${
                        activeTab === year ? "rotate-180" : ""
                      }`}
                    >
                      ⬇
                    </span>
                  </button>

                  {/* Tab Content */}
                  <div
                    className={`overflow-hidden transition-all duration-500
                    ${
                      activeTab === year
                        ? "max-h-full max-h-fit  py-4 px-6 bg-white open"
                        : "max-h-0 closed"
                    }`}
                  >
                    {researchData[year]?.map((item) => (
                      <div
                        key={item.id}
                        className="rounded-xl p-4 sm:p-8 text-left mb-4 "
                      >
                        <h2 className="mt-2 text-gray-800 text-sm sm:text-lg flex justify-center">
                          <span className="font-semibold text-primary-color "></span>
                          {item.title}
                        </h2>
                        <p className="text-gray-800 text-sm sm:text-lg flex justify-center mt-2">
                          <span className="font-semibold text-primary-color">
                            Researcher : 
                          </span>{" "}
                          {item.researcherName}
                        </p>
                        <p className="text-gray-800 text-sm sm:text-lg  py-6">
                          <span className="font-semibold text-primary-color"></span>{" "}
                          {item.description}
                        </p>
                        <div>
                        {item.files.map((file, index) => {
                          const filename = getFilenameFromUrl(file);
                          return (
                            <a
                              key={index}
                              href={file}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-primary-color font-semibold mt-4 inline-flex"
                            >
                              {filename}
                              <span className="ml-2">📄</span>
                            </a>
                          );
                        })}
                      </div>

                        {item.image ? (
                          <div className="border border-gray-300 rounded-xl p-4 sm:p-8 text-left mb-4 py-6 mt-5">
                            <img
                              src={item.image}
                              alt="Poster"
                              className="w-full h-auto rounded-md"
                            />
                            <h3 className="mt-2 text-lg font-semibold"></h3>
                            <p className="text-gray-700"></p>
                          </div>
                        ) : null}

                        {item.qrCode ? (
                          <div className="border border-gray-300 rounded-xl p-4 sm:p-8 grid  justify-center mb-4">
                            <>
                              <h3 className="text-lg font-semibold">QR Code</h3>
                              <QRCodeSVG
                                value={item.qrCode}
                                size={256}
                                level="H"
                              />
                              <p className="mt-2 text-gray-700">
                                Scan this QR code to visit the link.
                              </p>
                            </>
                          </div>
                        ) : null}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <h2 className="text-left text-primary-color text-4xl font-titillium mt-6 " id="publications">
            Publications
          </h2>
          <div className="w-full flex flex-col items-center mt-6 py-6">
          {" "}

          <div className="w-full sm:w-[98%] border border-gray-300 rounded-xl overflow-hidden">
            {publicationData.map((publication) => (
              <div key={publication.id} className="border-b border-gray-300">
                {/* Bar */}
                <button
                  className={`w-full text-left py-4 px-6 text-base sm:text-xl font-semibold flex justify-between items-center ${
                    activePublication === publication.id
                      ? "bg-gray-200 text-primary-color"
                      : "text-gray-600"
                  }`}
                  onClick={() => togglePublication(publication.id)}
                >
                  {publication.title}
                  <span
                    className={`ml-4 transform transition-transform duration-300 ${
                      activePublication === publication.id ? "rotate-180" : ""
                    }`}
                  >
                    ⬇
                  </span>
                </button>

                {/* Content */}
                <div
                  className={`overflow-hidden transition-all duration-500 ${
                    activePublication === publication.id
                      ? "max-h-full max-h-fit overflow-auto py-4 px-6 bg-white open"
                      : "max-h-0 closed"
                  }`}
                >
                  {/* Publication Details */}
                  <div className="h-auto w-full bg-white rounded-lg justify-between p-6">
                    {/* Title */}
                    <div className="flex justify-center items-center mb-4 lg:mb-0">
                      <p className="text-primary-color text-xl sm:text-2xl lg:text-3xl text-center lg:text-left font-titillium">
                        {publication.title}
                      </p>
                    </div>

                    {/* PDF Icon */}
                    <div className="text-3xl sm:text-4xl text-primary-color flex justify-end items-end mt-4 lg:mt-6">
                      <BsFileEarmarkPdfFill />
                    </div>

                    {/* Download Button */}
                    <div className="flex justify-end items-end mt-4">
                      <button
                        onClick={() =>
                          dispatch(downloadPublicationFile(publication.id))
                        }
                        className="text-primary-color underline font-inter"
                      >
                        Download Full Resource
                      </button>
                    </div>

                    {/* Details */}
                    <div className="text-left py-2 grid gap-y-3">
                      <h2 className="text-primary-color">
                        <span className="font-bold text-black font-inter">
                          Author(s) Name -
                        </span>{" "}
                        {publication.authors}
                      </h2>
                      <h2 className="text-black">
                        <span className="font-bold font-inter">
                          Publication Date -
                        </span>{" "}
                        <span className="font-inter">
                          {new Date(
                            publication.publication_date|| ""
                          ).toLocaleDateString("en-GB")}
                        </span>
                      </h2>
                      <h2 className="text-black">
                        <span className="font-bold text-black font-inter">
                          Journal Name -
                        </span>{" "}
                        <span className="font-inter">
                          {publication.journal_name}
                        </span>
                      </h2>
                      <h2 className="font-bold text-black">Abstract -</h2>
                      <p className="text-justify text-black font-inter">
                        {parse(publication.abstract)}
                       
                        
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResearchAndStudentLife;
